import classNames from 'classnames';
import React from 'react';

import Icon from 'src/components/Common/Icon';

interface UspProps {
  /** Content of the usp. */
  children: React.ReactNode;
  /** CSS class name */
  className?: string;
  /** Icon to display next to the content. */
  iconName: string;
}

/** Renders a unique selling point. */
const Usp = ({ children, className, iconName }: UspProps) => {
  return (
    <div className={classNames('ce-usp', className)}>
      <div className="ce-usp-icon mr-8">
        <Icon name={iconName} />
      </div>
      <div className="ce-usp-content">{children}</div>
    </div>
  );
};

Usp.defaultProps = {
  className: null,
};

export default Usp;
